import script from "./treatmentPlant.vue?vue&type=script&setup=true&lang=js"
export * from "./treatmentPlant.vue?vue&type=script&setup=true&lang=js"

import "./treatmentPlant.vue?vue&type=style&index=0&id=8b0f9152&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/zh-operate-subapp_prev/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b0f9152"]])

export default __exports__